// @flow
import styles from './ShareButtons.less';

import React from 'react';

import { Text, Section, Hidden } from 'seek-style-guide/react';
import FacebookButton from './FacebookButton/FacebookButton';
import TwitterButton from './TwitterButton/TwitterButton';
import LinkedInButton from './LinkedInButton/LinkedInButton';

type Props = {
  location: UrlLocation
};

export default ({ location }: Props) => (
  <Hidden component={Section} print>
    <Text small strong>
      <h2>Share this role</h2>
    </Text>
    <div className={styles.flex}>
      <FacebookButton location={location} />
      <TwitterButton location={location} />
      <LinkedInButton location={location} />
    </div>
  </Hidden>
);
